// TODO: fix in https://app.asana.com/0/1201994806276539/1205107468358935/f
// eslint-disable-next-line import/named
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { trackScreenLoad } from './trackers/mainTrackers';

export function useAnalytic(isTrackScreenLoad = true) {
    const location = useLocation();

    useEffect(() => {
        isTrackScreenLoad && trackScreenLoad();
    }, [location?.pathname]);
}
